import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/tailwindMerge/utils';

type Direction = 'horizontal' | 'vertical';

interface StackProps {
  children: ReactNode;
  direction?: Direction;
  className?: string;
}

export function Stack({
  children,
  direction = 'vertical',
  className = '',
}: StackProps) {
  const getStackClasses = () => {
    const baseClasses = 'flex';
    const directionClasses = direction === 'vertical' ? 'flex-col' : 'flex-row';

    return cn(baseClasses, directionClasses, className);
  };

  return <div className={getStackClasses()}>{children}</div>;
}
